<template>
  <v-dialog v-model="show" persistent max-width="800">
    <v-card>
      <v-card-title>Excise rates</v-card-title>
      <v-divider/>

      <v-simple-table fixed-header height="350" class="mt-2 mx-4">
        <thead>
          <tr>
            <th rowspan="2" style="border-right: thin solid #ccc">Effective</th>
            <th colspan="3" style="border-right: thin solid #ccc" class="text-center"><b>Spirits</b></th>
            <th colspan="3" class="text-center"><b>Wine</b></th>
          </tr>
          <tr>
            <th class="text-right">> 7%<br/>per LAA</th>
            <th class="text-right"><= 7%<br/>per litre</th>
            <th class="text-right" style="border-right: thin solid #ccc">Special duty<br/>per LAA</th>
            <th class="text-right"><= 1.2%<br/>per litre</th>
            <th class="text-right">> 1.2% & <= 7%<br/>per litre</th>
            <th class="text-right">> 7%<br/>per litre</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rate in rates" :key="rate.date">
            <td class="text-right" style="border-right: thin solid #ccc">{{rate.effectiveDate | formatDate}}</td>
            <td class="text-right">${{rate.rateGT7 | number(3)}}</td>
            <td class="text-right">${{rate.rateLE7 | number(3)}}</td>
            <td class="text-right" style="border-right: thin solid #ccc">${{rate.specialDuty | number(3)}}</td>
            <td class="text-right">${{rate.wineLE12 | number(3)}}</td>
            <td class="text-right">${{rate.wineLE7 | number(3)}}</td>
            <td class="text-right">${{rate.wineGT7 | number(3)}}</td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="cancel">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>

export default {
  name: 'ReportsExciseRates',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      rates: []
    }
  },
  watch: {
    value() {
      this.show = this.value;
    },
  },
  async created() {
    const results = await this.$apiCall(`query ReportsExciseRates {
                                            exciseRates {
                                              effectiveDate,rateLE7,rateGT7,specialDuty,wineLE12, wineLE7, wineGT7
                                            }
                                          }`,
                                        {});
    if (!results.error)
      this.rates = results.data.exciseRates;
  },
  methods: {
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>